import { isBookable } from './modules'

/**
 * AP-40 — **Bereichs-Dashboards**: der gemeinsame Vertrag zwischen den Endpunkten
 * `GET /<bereich>/dashboard` und den Seiten unter `components/dashboard/`.
 *
 * Herausgelöst aus dem Projekt-Dashboard (AP-35 Blatt 8 5.1), damit alle Bereiche
 * gleich funktionieren: ein Aufruf je Dashboard, jede Kachel mit Zahl und Ziel.
 */

/** „alle" oder „meine" — eine Wahl, keine Rechtelage (AP-35 Blatt 8 5.1, MD-10). */
export type DashboardScope = 'all' | 'mine'

export interface DashboardTile {
  /** `false` = Baustein nicht gebucht → grau mit Erklärung (MD-7). */
  available: boolean
  /** Die große Zahl der Kachel. */
  count: number
  /** Betrag darunter — nur mit dem Preisrecht des Bereichs in der Antwort (6.3). */
  amount?: number | null
  /** Wohin der Klick führt: die Liste mit gesetztem Filter (6.4, MD-9). */
  href?: string
  /** Fehlender Baustein bei `available: false` — der Schlüssel, die Oberfläche zeigt seinen Namen. */
  module?: string
  /** Grund bei `available: false`. */
  reason?: string
  [feld: string]: unknown
}

export interface DashboardAntwort {
  scope: DashboardScope
  /** Ob der Umschalter „alle / meine" erscheint — nur wer mehr als das Eigene sehen darf (6.5). */
  scopeSwitch?: boolean
  /** Kacheln je Schlüssel. **Fehlt eine, fehlt das Recht** (MD-7) — sie wird nicht gezeigt. */
  tiles: Record<string, DashboardTile>
  /** Kurze Listen (höchstens 8 Zeilen), je Schlüssel. */
  lists?: Record<string, unknown[]>
  /** Zeitpunkt der Berechnung (ISO) — für „Aktualisiert vor … s". */
  stand: string
}

/**
 * Wie eine Kachel eines **Bausteins** erscheint (MD-7, Auftraggeber 27.9.2026):
 *
 * - `GEBUCHT` → rechnen und zeigen;
 * - `NICHT_GEBUCHT` → grau mit Erklärung („Der Baustein … ist nicht gebucht") — der
 *   Hinweis auf etwas, das der Mandant kaufen kann;
 * - `NICHT_BUCHBAR` → **gar nicht**: Ein Baustein in Entwicklung wird nicht beworben.
 */
export type BausteinLage = 'GEBUCHT' | 'NICHT_GEBUCHT' | 'NICHT_BUCHBAR'

export function bausteinLage(modul: string, aktiveModule: readonly string[] | null | undefined): BausteinLage {
  if ((aktiveModule ?? []).includes(modul)) return 'GEBUCHT'
  return isBookable(modul) ? 'NICHT_GEBUCHT' : 'NICHT_BUCHBAR'
}

/** Schlüssel der gespeicherten Wahl „alle / meine" je Bereich (AP-23, nur für den Benutzer). */
export const dashboardEinstellung = (bereich: string) => `dashboard_${bereich}`
